export default "__VITE_ASSET__cJ2BY0Mm__"